import React from "react";
import {
	getCategoryAxes,
	getLegendFont,
	getLegendHeight,
	getValuesAxes,
	getDefaults,
} from "./chartUtilities";
import * as kc from "@progress/kendo-react-charts";

export const BarColumnChart = ({ dataSets, def, type }) => {
	const legendFont = getLegendFont();
	const legendHeight = getLegendHeight();
	const defaults = getDefaults("colours");

	const colours = def.format.colours ?? {};

	const xAxes = def.format.axes.filter((e) => e.type === "x");
	const yAxes = def.format.axes.filter(
		(e) =>
			e.type === "y" &&
			dataSets.some((w) => (w.def ? w.def.axis : e.name) === e.name)
	);

	const categoryAxes = getCategoryAxes(xAxes, yAxes, def, legendFont);
	const valueAxes = getValuesAxes(yAxes, xAxes, def, legendFont);

	const defaultSeriesDef = {
		showOnLegend: false,
		bar: {
			colour: defaults.barChart.bar,
			opacity: 1,
		},
	};

	const seriesItems = dataSets.map((e, index) => {
		const categories = xAxes[0].categories ?? [];

		const seriesDef = e.def ?? def.format.data[0] ?? defaultSeriesDef;

		if (seriesDef.bar) {
		} else {
			seriesDef.bar = {};
		}

		const sorted = e.data.sort((a, b) => {
			if (xAxes.length === 0 || categories.length === 0) {
				return 0;
			}

			return categories.indexOf(a.label) - categories.indexOf(b.label);
		});

		return (
			<kc.ChartSeriesItem
				key={e.name ?? `series${index + 1}`}
				type={type}
				color={seriesDef.bar.colour ?? defaults.barChart.bar}
				name={e.name ?? `Series ${index + 1}`}
				axis={seriesDef.axis ?? "y1"}
				data={sorted}
				visibleInLegend={seriesDef.showOnLegend ?? true}
				field="value"
				opacity={seriesDef.bar.opacity ?? 1}
				stack={true}
			/>
		);
	});

	return (
		<kc.Chart className={"h-full"}>
			<kc.ChartArea
				opacity={0}
				margin={{
					top: 0,
				}}
			/>

			<kc.ChartLegend
				position="bottom"
				labels={{
					font: legendFont,
				}}
				orientation={"vertical"}
				height={legendHeight}
			/>

			<kc.ChartAxisDefaults
				majorGridLines={{
					color: colours.gridLine ?? "white",
					width: 1,
				}}
			/>

			<kc.ChartSeries>{seriesItems}</kc.ChartSeries>

			<kc.ChartValueAxis>{valueAxes}</kc.ChartValueAxis>

			<kc.ChartCategoryAxis>{categoryAxes}</kc.ChartCategoryAxis>
		</kc.Chart>
	);
};
